export const generateLine = (lan = 'he') => {
    const views = [
        '78K צפיות',
        '123K צפיות',
        '325K צפיות',
        '412K צפיות',
        '781K צפיות',
        '1.1M צפיות',
        '1.5M צפיות',
        '1.85M צפיות'
    ]

    const from = [
        'לפני 27 דקות',
        'לפני שעתיים',
        'לפני 3 ימים',
        'לפני שבוע',
        'לפני 2 שבועות',
        'לפני חודש',
        'לפני 3 חודשים',
        'לפני 2 שנים'
    ]

    const viewsEnglish = [
        '78K views',
        '123K views',
        '325K views',
        '412K views',
        '781K views',
        '1.1M views',
        '1.5M views',
    ]

    const fromEnglish = [
        '27 minutes ago',
        '2 hours ago',
        '3 days ago',
        '1 week ago',
        '2 weeks ago',
        '1 month ago',
        '3 months ago',
    ]
    if (lan === 'he') return `${views[Math.floor(Math.random() * views.length)]} • ${from[Math.floor(Math.random() * from.length)]}`
    else return `${viewsEnglish[Math.floor(Math.random() * viewsEnglish.length)]} • ${fromEnglish[Math.floor(Math.random() * fromEnglish.length)]}`
}

export const rolesTranslations = {
    ideaMaker: 'הוגה רעיונות',
    thumbnailEditor: 'עורך טאמבניילים',
    researcher: 'תחקירן',
    scripter: 'תסריטאי',
    producer: 'מפיק',
    admin: 'אדמין',
    archived: 'ארכיון'
}

export const departmentsTranslations = {
    ideaMaker: 'קריאייטיב',
    researcher: 'חקר',
    producer: 'הפקה',
}

export const rolesRank = {
    ideaMaker: 1,
    researcher: 2,
    scripter: 3,
    thumbnailEditor: 3.5,
    producer: 4,
    admin: 6
}

export const rolesColors = {
    ideaMaker: 'blue',
    researcher: 'yellow',
    scripter: 'green',
    producer: 'red',
    thumbnailEditor: 'purple',
    admin: 'white',
}

export const mockVideos = [
    {
        title: 'How to be financially stable',
        channelName: 'Money Matters',
        length: '4:40',
        image: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711884530/demo-videos/m7dl5lvhw1nzt9l540gi.jpg',
        channelImage: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711887160/demo-videos/ru0scueslf3wdslnbuqe.png'
    },
    {
        title: '5 secrets to hit on any girl!',
        channelName: 'The Pickup bros',
        length: '7:17',
        image: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711884483/demo-videos/pjswkynh1mnnem9qmaek.jpg',
        channelImage: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711887449/demo-videos/fc4mfzp32lr1fpnftoud.jpg'
    },
    {
        title: 'God of war gameplay part 14 - Big snake!',
        channelName: 'Gamerz USA',
        length: '14:40',
        image: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711887540/demo-videos/uhw8eqcaska4fgwwuwjf.jpg',
        channelImage: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711887602/demo-videos/hjbpkiqcu7pa4vmxud9g.jpg'
    },
    {
        title: '1 Hour of Relaxing Rain Sounds (sleep better)',
        channelName: 'Ambience Sounds',
        length: '60:00',
        image: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711887788/demo-videos/xkhaacwobv4ewudeohnh.jpg',
        channelImage: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711887783/demo-videos/jcargr5ppq6p1e28ce8w.jpg'
    },
    {
        title: 'Celebrating 10K premium subscribers!',
        channelName: 'Mr. Beast',
        length: '8:06',
        image: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711887992/demo-videos/qcyukps87ftqjim8hxku.jpg',
        channelImage: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711887907/demo-videos/sjjfw7r3tzgis6j5obck.jpg'
    },
    {
        title: 'Luffy vs Lucci is amazing! (reaction)',
        channelName: 'Anime Reacts',
        length: '12:41',
        image: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711888165/demo-videos/gvldqsek2tcfyme45k2h.jpg',
        channelImage: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711888286/demo-videos/jk5ll846c4m8js9e9fbd.jpg'
    },
    {
        title: 'Best of Justin Bieber world tour 2023',
        channelName: 'justinbieberVEVO',
        length: '55:00',
        image: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711888530/demo-videos/femlwauhr5nskq9dhdhp.jpg',
        channelImage: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711888685/demo-videos/kxpra0czpmahy6htfxns.jpg'
    },
    {
        title: 'Create the best thumbnails for your videos!',
        channelName: 'Thumbnail Master',
        length: '6:21',
        image: 'https://marketplace.canva.com/EAEqfS4X0Xw/1/0/1600w/canva-most-attractive-youtube-thumbnail-wK95f3XNRaM.jpg',
        channelImage: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711889081/demo-videos/mjofaxtof9jjflrlau5o.jpg'
    },
    {
        title: 'Top 10 funniest Ted Mosby moments',
        channelName: 'HIMYM Official',
        length: '7:32',
        image: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711889229/demo-videos/ouczsbtosj11m4blhnfo.jpg',
        channelImage: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711889326/demo-videos/jy7v3uycvwb6en4kvwwy.jpg'
    },
    {
        title: 'Gangam Style',
        channelName: 'PSY',
        length: '3:51',
        image: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711894625/demo-videos/wztciaee6bk6vlqc4idh.jpg',
        channelImage: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711894783/demo-videos/jtzkpet8jaajvppwcv74.jpg'
    },
    {
        title: 'My personal opinion about the war between israel and palestine',
        channelName: 'Know it now',
        length: '3:49',
        image: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711889546/demo-videos/afue8uyu8knkjqcqgvjy.jpg',
        channelImage: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711889597/demo-videos/r25okssqklz1nklltynl.png'
    },
    {
        title: '30 minutes of top blues music',
        channelName: 'XVC Music',
        length: '30:02',
        image: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711894989/demo-videos/cdpyvj1a16cncjmdrimy.jpg',
        channelImage: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711895087/demo-videos/mgqcwzufjx6f3s5rofwx.png'
    },
    {
        title: '1 Guy VS 50 Girlfriends',
        channelName: 'Airrack',
        length: '35:22',
        image: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711896698/demo-videos/gyhwgwcqifytorituthx.jpg',
        channelImage: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711896797/demo-videos/cdtmojxclzlqkcsfhvxn.jpg'
    },
    {
        title: 'I Tested 1-Star Drive Thrus',
        channelName: 'Ryan Trahan',
        length: '11:27',
        image: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711897019/demo-videos/ipk1peievvlekn3nv90h.jpg',
        channelImage: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711897060/demo-videos/alucagi14vzewpmiu3to.jpg'
    },
    {
        title: 'Driving the New Fastest Car Ever Made!',
        channelName: 'MotorTrend',
        length: '12:06',
        image: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711897280/demo-videos/p4smh1cjw29jrdywbnt7.jpg',
        channelImage: 'https://res.cloudinary.com/dfmtbntrc/image/upload/v1711897414/demo-videos/ytlmm6twanec9xddipza.jpg'
    },
]

